<template>
    <l-map v-if="entity.geo_lat && entity.geo_lng" style="height: 500px" @click="resizeMap" :zoom="leaflet.zoom" :center="leaflet.center" :options="leaflet.options" ref="hotelMap" id="hotelMap">
      <l-tile-layer :url="leaflet.url" :attribution="leaflet.attribution"></l-tile-layer>
    </l-map>
  <div v-else class="text-center m-3">
    <h2>{{$t('_notMap') }}</h2>
  </div>
</template>

<script>
import { LMap, LTileLayer, L } from 'vue2-leaflet'
import 'leaflet/dist/leaflet.css'
import { defaultLeaflet } from '@/conf/leaflet'

export default {
  components: {
    LMap,
    LTileLayer
    // LMarker
  },

  props: {
    entity: Object
  },

  data () {
    return {
      leaflet: defaultLeaflet,
    }
  },

  mounted () {
    if (this.entity.geo_lat && this.entity.geo_lng) {
      let latlng = L.latLng(
        this.entity.geo_lat,
        this.entity.geo_lng
      )

      let marker = new L.Marker(latlng, {
        draggable: false
      })

      marker.addTo(this.$refs.hotelMap.mapObject)

      // recompute center and zoom
      this.$refs.hotelMap.mapObject.setZoomAround(latlng, 14)
      this.$refs.hotelMap.mapObject.panTo(latlng)

      /**
       * This is called whenever an observed element is
       * in view or went out of view.
       */
      const onIntersection = (entries, observer) => {
        for (const { isIntersecting, target } of entries) {
          if (isIntersecting) {
            this.resizeMap()
            observer.unobserve(target)
          }
        }
      }

      /**
       * The options for the observer.
       * 0px on the rootMargin says that the observer triggers
       */
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: [0]
      }

      /**
       * Permet d'observer les changements de manière asynchronous
       * au niveau de notre div s'il détecte un changement alors il l'applique
       * @param onIntersection Nouvelles options de notre div
       * @param options Options par défaut
       * @type {IntersectionObserver}
       */
      const observer = new IntersectionObserver(onIntersection, options)

      // On observe la div de la map : l-map
      observer.observe(this.$refs.hotelMap.$el)
    }
  },

  methods: {
    resizeMap () {
      this.$refs.hotelMap.mapObject.invalidateSize()
    }
  }
}
</script>
